import { Outlet, createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_auth/tm-invoices")({
  component: () => <Outlet />,
});
